import useAddress from '@/containers/SubscriptionFormPageNew/Components/Address/useAddress'
import SDFormControl from '@/shared/components/SDComponentsNewDesign/SDFormControl/SDFormControl'
import getError from '@/containers/SubscriptionFormPageNew/getError'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'

const Staircase = () => {
  const { t, updateAddress, errors, staircase, isApartment, showStaircase, showAddressFields } = useAddress()

  if (!showStaircase || !showAddressFields || !isApartment) {
    return null
  }

  return (
    <SDFormControl plainLabel error={getError('staircase', errors)}>
      <SDInput
        label={t('subscriptionForm:address_module.staircase')}
        onBlur={staircase => updateAddress({ staircase })}
        currentValue={staircase}
      />
    </SDFormControl>
  )
}

export default Staircase
